import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';

export const CardGrid = styled(Grid)({
    display: 'flex',
    justifyContent: 'center',
  });
  
  export const CustomCard = styled(Card)(({ theme }) => ({
    maxWidth: '100%', // Default to full width for small screens
    width: 345,       // Base width for medium and larger screens
    [theme.breakpoints.up('sm')]: {
      maxWidth: 350, // Ensures it doesn't expand too much on medium screens
    },
    [theme.breakpoints.up('md')]: {
      maxWidth:345 , // Slightly larger cards for larger screens
    },
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
    borderRadius: '20px',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
    },
  }));
  
  
 export const CardMediaStyled = styled(CardMedia)({
    objectFit: 'cover',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
  });
  
  export const CardContentStyled = styled(CardContent)({
    padding: 24,
  });